import React, { useState, useEffect } from 'react';
import { getProductForecastList } from '../../../services/ProductService';
import { Spinner } from 'react-bootstrap';
import Select from 'react-select';

const generateMonthRanges = () => {
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const today = new Date();
    const startMonth = today.getMonth();
    const startYear = today.getFullYear();

    const ranges = Array.from({ length: 4 }, (_, i) => {
        const startDate = new Date(startYear, startMonth, 1);
        const endDate = new Date(startYear, startMonth + (i + 1) * 3 - 1, 1);
        const label = `${monthNames[startDate.getMonth()]} ${startDate.getFullYear()} - ${monthNames[endDate.getMonth()]}, ${endDate.getFullYear()}`;
        return { value: (i + 1) * 3, label };
    });
    return ranges;
};

const generateQuarterlyRanges = () => {
    const today = new Date();
    const currentMonth = today.getMonth(); // 0-11 (Jan-Dec)
    const currentYear = today.getFullYear();
    
    // Determine current quarter (1-4)
    const currentQuarter = Math.floor(currentMonth / 3) + 1;
    
    const ranges = [];
    
    for (let i = 0; i < 4; i++) {
        const quarter = (currentQuarter + i) % 4 || 4; // Wrap around to 4 if modulo is 0
        const year = currentYear + Math.floor((currentQuarter + i - 1) / 4);
        
        ranges.push(`${year} Q${quarter}`);
    }
    
    return ranges;
};


const DynamicTableHead = ({ periodvalue, viewType }) => {
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    if (viewType === 'monthly') {
        const today = new Date();
        const startMonth = today.getMonth();
        const startYear = today.getFullYear();

        const ranges = Array.from({ length: periodvalue }, (_, i) => {
            const startDate = new Date(startYear, startMonth + i, 1);
            return `${monthNames[startDate.getMonth()]} ${startDate.getFullYear()}`;
        });

        return ranges.map((item, index) => <th key={index}>{item}</th>);
    } else if (viewType === 'quarterly') {
        const quarterlyRanges = generateQuarterlyRanges();
        return quarterlyRanges.map((item, index) => <th key={index}>{item}</th>);
    }
};

const ForecastProducts = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState([]);
    const [period, setPeriod] = useState(generateMonthRanges()[0]);
    const [viewType, setViewType] = useState('monthly');

    const handleForecastChange = (viewType, timeperiod) => {
        setIsLoading(true);
        setData([]);
        getProductForecastList(viewType, timeperiod).then((response) => {
            const resp_data = response.data.data;
            setData(resp_data);
            setIsLoading(false);
        }).catch((error) => {
            console.log(error.response.data.message);
            setIsLoading(false);
        });
    };

    useEffect(() => {
        handleForecastChange(viewType, period.value || 3);
    }, [period, viewType]);


    const hanldeChangeViewType = (data) => {
        setViewType(data.value)
        if (data.value === 'monthly') {
            setPeriod(generateMonthRanges()[0]);
        }
        else {
            setPeriod({ value: 4, label: '4 Quater' });
        }
    }

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-xl-12 mb-3">
                    <div className="card mb-0" style={{ minHeight: '15rem', height: "100%" }}>
                        <div className="card-body p-0">
                            <div className="tbl-caption d-flex justify-content-between text-wrap align-items-center p-3">
                                <h4 className="mb-0">Forecast All Material</h4>
                                <div className='d-flex align-items-center'>
                                    <label className='me-2 mb-0'>View Type</label>
                                    <Select
                                        value={{ value: viewType, label: viewType === 'monthly' ? 'Monthly' : 'Quarterly' }}
                                        onChange={(data) => hanldeChangeViewType(data)}
                                        options={[
                                            { value: 'monthly', label: 'Monthly' },
                                            { value: 'quarterly', label: 'Quarterly' },
                                        ]}
                                        className='react-select me-3'
                                        classNamePrefix='select'
                                    />
                                    {viewType === 'monthly' &&
                                        <>
                                            <label className='me-2 mb-0'>Time Period</label>
                                            <Select
                                                value={period}
                                                onChange={(data) => setPeriod(data)}
                                                placeholder={"Select Time Period"}
                                                isClearable={false}
                                                options={generateMonthRanges()}
                                                className='react-select'
                                                classNamePrefix='select'
                                            />
                                        </>
                                    }
                                </div>
                            </div>

                            <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                                <div id="employee-tbl_wrapper" className="dataTables_wrapper no-footer">
                                    <table id="empoloyees-tblwrapper" className="table ItemsCheckboxSec dataTable no-footer mb-0">
                                        <thead>
                                            <tr>
                                                <th>Material Name</th>
                                                <DynamicTableHead periodvalue={period.value} viewType={viewType} />
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {isLoading ? (
                                                <tr>
                                                    <td colSpan={period.value + 1}>
                                                        <div className='d-flex align-items-center flex-column'>
                                                            <Spinner animation="border" role="status">
                                                                <span className="visually-hidden"></span>
                                                            </Spinner>
                                                            <h5>Loading ...</h5>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ) : data.length ? (
                                                data.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{item.product}</td>
                                                        {item.forecast.map((itm, ind) => (
                                                            <td key={ind}>{itm.actual}</td>
                                                        ))}
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan={period.value + 1}>
                                                        <div className='d-flex align-items-center flex-column'>
                                                            <h5>No Data Found</h5>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>

                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ForecastProducts;
